exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tlbtn{font-family:Mulish;letter-spacing:.05em;font-size:14px;font-weight:700}.txttitle{color:#005073}.card_title{font-size:18px}", ""]);

// exports
